import { Box, Card, CardContent, Stack, Typography, Button, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PaymentFailPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const formId = searchParams.get('Shp_formId') ?? '';

  const handleRetry = () => {
    navigate(formId ? `/payment/${formId}` : '/main');
  };

  return (
    <Stack
      sx={{ height: '100%', alignItems: 'center', justifyContent: 'center', px: 2 }}
    >
      <Card
        sx={{
          maxWidth: 520,
          width: '100%',
          boxShadow: theme.shadows[10],
          borderRadius: 3
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3} alignItems="center" textAlign="center">
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                backgroundColor: theme.palette.error.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white'
              }}
            >
              <Icon icon="mdi:close-thick" width={36} height={36} />
            </Box>

            <Typography variant="h5" fontWeight={700}>
              Оплата не прошла
            </Typography>

            <Typography variant="body1" color="text.secondary">
              Платёж был отменён или завершился с ошибкой. Средства не списаны — попробуйте ещё раз.
            </Typography>

            <Stack spacing={1.5} sx={{ width: '100%', mt: 2 }}>
              <Button
                size="large"
                variant="contained"
                fullWidth
                onClick={handleRetry}
                sx={{ py: 1.5, fontWeight: 600 }}
                startIcon={<Icon icon="mdi:refresh" />}
              >
                Попробовать снова
              </Button>
              <Button
                size="large"
                variant="text"
                fullWidth
                onClick={() => navigate('/main')}
                sx={{ py: 1.5, fontWeight: 600 }}
              >
                На главную
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default PaymentFailPage;
